import { isNil } from 'lodash';
import React from 'react';
import { MealPlanFoodItem } from 'src/pages/consumer/meal-plans/checkout/types';
import { getTopKCuisines } from 'src/shared/design-system/DishFirstCard/utils';

interface DishModalTitleProps {
  foodItem: Pick<MealPlanFoodItem, 'name'> & Partial<Pick<MealPlanFoodItem, 'cuisineCategories'>>;
  dishNameRef?: (ref: HTMLParagraphElement | null) => void;
}

export const DishModalTitle: React.FC<DishModalTitleProps> = ({ foodItem, dishNameRef }) => {
  const cuisines = !isNil(foodItem.cuisineCategories)
    ? getTopKCuisines({ cuisineCategories: foodItem.cuisineCategories })
    : undefined;

  return (
    <div className='pt-4'>
      {/* Cuisines */}
      {cuisines && (
        <p className='no-scrollbar overflow-x-auto overflow-y-hidden whitespace-nowrap text-caption-400 text-eggplant'>
          {cuisines}
        </p>
      )}

      {/* Food item name */}
      <p ref={dishNameRef} className='mt-1 text-h4-bold text-eggplant'>
        {foodItem.name}
      </p>
    </div>
  );
};
